import { render, staticRenderFns } from "./DutyFromTo.vue?vue&type=template&id=d24494fc&"
import script from "./DutyFromTo.vue?vue&type=script&lang=js&"
export * from "./DutyFromTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports